import React, { useEffect, useState } from 'react';
import axios from 'axios';
import firebase from "firebase/compat/app";
import { firebaseConfig } from './firebase'

import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import './Offers.scss'

import { CalendarMonth, ComputerSharp } from '@mui/icons-material';
import { FaWrench } from 'react-icons/fa';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';


import { toast } from "react-toastify";
import { db } from "../firebase.js";
import BedIcon from '@mui/icons-material/Bed';
import BathtubIcon from '@mui/icons-material/Bathtub';
import GrassIcon from '@mui/icons-material/Grass';
import ConstructionIcon from '@mui/icons-material/Construction';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import VillaIcon from '@mui/icons-material/Villa';
import DateRangeIcon from '@mui/icons-material/DateRange';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import FoundationIcon from '@mui/icons-material/Foundation';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import EmailIcon from '@mui/icons-material/Email';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import HouseSidingIcon from '@mui/icons-material/HouseSiding';
import FenceIcon from '@mui/icons-material/Fence';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PersonIcon from '@mui/icons-material/Person';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AddIcon from '@mui/icons-material/Add';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import BusinessIcon from '@mui/icons-material/Business';
import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import GavelIcon from '@mui/icons-material/Gavel';
import PhoneIcon from '@mui/icons-material/Phone';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CottageIcon from '@mui/icons-material/Cottage';
import PaidIcon from '@mui/icons-material/Paid';
import ListingItem from "../components/ListingItem.jsx";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import NewPatientModal from './NewPatientModal.jsx.jsx'
import { Button, Modal } from 'react-bootstrap';
import LockIcon from '@mui/icons-material/Lock';
import SpeedIcon from '@mui/icons-material/Speed';
import SupportIcon from '@mui/icons-material/Support';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import ReceiptRoundedIcon from "@mui/icons-material/ReceiptRounded";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import TimelineRoundedIcon from "@mui/icons-material/TimelineRounded";
import BubbleChartRoundedIcon from "@mui/icons-material/BubbleChartRounded";
import WalletRoundedIcon from "@mui/icons-material/WalletRounded";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import SavingsRoundedIcon from "@mui/icons-material/SavingsRounded";
import MonetizationOnRoundedIcon from "@mui/icons-material/MonetizationOnRounded";
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import HouseIcon from '@mui/icons-material/House';
import GppGoodIcon from '@mui/icons-material/GppGood';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PieChartIcon from '@mui/icons-material/PieChart';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SearchIcon from '@mui/icons-material/Search';
import CalculateIcon from '@mui/icons-material/Calculate';
import AddHomeIcon from '@mui/icons-material/AddHome';
import SchoolIcon from '@mui/icons-material/School';
import GroupIcon from '@mui/icons-material/Group';
import { MapContainer, Popup, Marker, TileLayer } from "react-leaflet";
import { getAuth } from "firebase/auth";
import Contact from "../components/Contact";
import { doSignOut } from "./auth.js";
import { useAuth } from "./authContext";
import GaugeComponent from 'react-gauge-component';
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import {
  FaBath,
  FaBed,
  FaChair,
  FaMapMarkerAlt,
  FaParking,
  FaShare,
} from "react-icons/fa";
import { CardMedia } from "@mui/material";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import PeopleIcon from '@mui/icons-material/People';
import { Chip } from "@mui/material";
import StateModal from "./StateModal.jsx";
import TenantModal from "./TenantModal.jsx";
import UpsellModal from './UpsellModal.jsx';
import ProfileComponent from './ProfileComponent.jsx';
import { CreditCard } from '@mui/icons-material';

firebase.initializeApp(firebaseConfig);


const SkipTrace = () => {
  const { currentUser } = useAuth()

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    addressLine1: '',
    addressLine2: ''
  });
  const [resultData, setResultData] = useState(null);
  const [error, setError] = useState(null);
  const [user, setUser] = useState(null);

  console.log(resultData)
  const DealExplorerUpsell = () => {
    const [open, setOpen] = React.useState(false);
  
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
  
    return (
      <>
        <button onClick={handleOpen}>Deal Explorer</button>
        <UpsellModal open={open} onClose={handleClose} />
      </>
    );
  };


  useEffect(() => {
    setTimeout(()=>{

    firebase
      .firestore()
      .collection("users")
      .doc(currentUser.uid)
      .get()
      .then((snapshot) => {
        if (snapshot.exists) {
          setUser(snapshot.data());
          console.log("USERID", currentUser.uid)
          console.log("USER", user)

        } else {
          console.log("does not exist");
        }
      });
    }, 1000)
}, []);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setResultData(null);

    try {
      const response = await axios.post(
        'https://devapi.endato.com/Contact/Enrich',
        {
          FirstName: formData.firstName,
          LastName: formData.lastName,
          Address: {
            addressLine1: formData.addressLine1,
            addressLine2: formData.addressLine2,
          },
        },
        {
          headers: {
            'galaxy-ap-name': '9c98fe55f8014288bfe14ea5918a433e',
            'galaxy-ap-password': '39b84f31734c4a21be261904d59cddc5',
            'galaxy-search-type': 'DevAPIContactEnrich',
          },
        }
      );
      setResultData(response.data);
    } catch (err) {
      setError('An error occurred while fetching data.');
    }
  };

  const OpenModalButton = () => {
    const [open, setOpen] = React.useState(false);
  
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
  
    return (
      <>
        <button onClick={handleOpen}>Housing Authority</button>
        <StateModal open={open} onClose={handleClose} />
      </>
    );
  };


  
  const OpenModalButton2 = () => {
    const [open, setOpen] = React.useState(false);
  
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
  
    return (
      <>
        <button onClick={handleOpen}>Tenant Lookup</button>
        <TenantModal open={open} onClose={handleClose} />
      </>
    );
  };

  if (!user ) {
    return <div></div>
  } else
  return (
  
    <div className="offer" style={{ backgroundColor: '#f1f4f9'}}>
     
      {/* <OpenModalButton/> */}

      <div style={{ display: "flex",  }}>
  <Sidebar
    style={{
      backgroundColor: '#000222',
      flex: '0 0 250px', // Fixed width for the sidebar
    }}
  >
            <Menu style={{ backgroundColor: '#000222' }}>
              <MenuItem>
                <div style={{ marginLeft: -43, backgroundColor: 'white' }}>
                  <img
                    src="https://i.ibb.co/s2dBvDt/elevate.png"
                    alt="logo"
                    className="ml-4 mt-12 -p-4 "
                    width={300}
                  ></img>
                </div>
              </MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white', marginTop: '50px' }} onClick={() => window.location = 'fmrexplorer'} icon={<LocationOnIcon />}> FMR Explorer </MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.location = 'propertylookup'} icon={<SearchIcon />}>Market Research</MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.location = 'dealcalculator'} icon={<CalculateIcon />}>Deal Calculator</MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.location = 'dealexplorer'} icon={<AddHomeIcon />}>Deal Explorer</MenuItem>

              
<MenuItem
  style={{
    backgroundColor: '#000222',
    color: 'white',
    fontSize: 18,
    display: 'flex',
    alignItems: 'center',
  }}
  onClick={() => window.location = 'dealexplorerai'}
>
  <span style={{ display: 'flex', alignItems: 'center' }}>
    <AutoAwesomeIcon fontSize="small" style={{ marginRight:18}}/>
    Deal Explorer Ai
    <Chip
      label="beta"
      size="small"
      style={{
        backgroundColor: 'white',
        color: '#000222',
        fontSize: 10,
        fontWeight: 600,
        height: 18,
        borderRadius: 9999,
        marginLeft:4
      }}
    />
  </span>
</MenuItem>   

              <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'skiptrace'} icon={<VisibilityIcon />}>Skip Trace</MenuItem>

<MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.location = 'rentcast'} icon={<SpeedIcon />}>Rent Reveal</MenuItem>
                <MenuItem style={{ color: 'white', backgroundColor: '#000222' }} icon={<HouseIcon />}> <OpenModalButton /> </MenuItem>
                <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} icon={<EmojiPeopleIcon />}> <OpenModalButton2 /> </MenuItem>
                <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} icon={<SupportIcon />} onClick={() => window.open('https://elevatecoachingrei.steadilypartner.com/', "_blank")}> Landlord Insurance </MenuItem>

              <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'community'} icon={<PeopleIcon />}>Community Hub</MenuItem>
                <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} icon={<ComputerSharp />} onClick={() => window.open('https://section8guys.com/training', "_blank")}> Next Webinar </MenuItem>

              <SubMenu label="Book a Session" style={{ backgroundColor: '#000222', color: 'white' }} icon={<CalendarMonth />}>
               
                <MenuItem icon={<PeopleIcon />} style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://calendly.com/elevaterei/googlemeet?back=1&month=2025-01', "_blank")}>
                  1-on-1s
                </MenuItem>
                <MenuItem icon={<BusinessIcon />} style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://calendly.com/elevaterei/inoffice?back=1&month=2025-01', "_blank")}>
                  Day in the Office
                </MenuItem>
                <MenuItem icon={<DirectionsCarFilledIcon />} style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://calendly.com/elevaterei/ridealong?back=1&month=2025-01', "_blank")}>
                  Ride Along
                </MenuItem>
              </SubMenu>
             
    
              <SubMenu label="Investor Solutions" style={{ backgroundColor: '#000222', color: 'white' }} icon={<BusinessIcon />}>
                              <MenuItem icon={<LockIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Asset Protection </MenuItem>
                                              <MenuItem icon={<AttachMoneyIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Business Funding </MenuItem>
                <MenuItem icon={<CreditScoreIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Credit Builder </MenuItem>
                <MenuItem icon={<FaWrench />} onClick={() => window.open('https://elevatecoachingrei.thecreditbrothers.com/learn-more?entry_source=elevatecoachingrei', "_blank")}> Credit Repair </MenuItem>
                <MenuItem icon={<AddIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}>Entity Formation </MenuItem>
                <MenuItem icon={<RequestQuoteIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Taxes </MenuItem>
              </SubMenu>
                <MenuItem style={{ color: 'white', backgroundColor: '#000222' }} onClick={() => window.open('https://lendsimpli.com/elevate/', "_blank")} icon={<CurrencyExchangeIcon />}> Property Loans </MenuItem>
                              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://www.skool.com/elevate-wsection-8-8185', "_blank")} icon={<SchoolIcon />}>Skool Community</MenuItem>

              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} icon={<LogoutRoundedIcon />} onClick={() => doSignOut({ callbackUrl: '/', redirect: true })}> Logout </MenuItem>
              <div style={{ ...styles.container1, backgroundColor: '#000222' }}>
                <ProfileComponent user={user} />
              </div>
            </Menu>
          </Sidebar>
      <div className="w-40">
    </div>
      
        <>
        <main>
        <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', maxWidth: '1000px', margin: '0 auto' }}>
        <h1 className="offer__title2">Skip Tracing</h1>
        <h4 style= {{textAlign:'center'}}>Welcome to the Skip Tracing! </h4>
      <h4 style= {{textAlign:'center', marginBottom:'10px'}}>Enter an address and owner name to get started</h4>
      <div></div>
      <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '15px', marginBottom: '20px' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
        <label style={{ marginBottom: '5px' }}>First Name:</label>
          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
            style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '5px' }}>Last Name:</label>
          <input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
            style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '5px' }}>Street</label>
          <input
            type="text"
            name="addressLine1"
            value={formData.addressLine1}
            onChange={handleChange}
            required
            style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '5px' }}>City, State, and Zip</label>
          <input
            type="text"
            name="addressLine2"
            value={formData.addressLine2}
            onChange={handleChange}
            style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
          />
        </div>
        <button
          type="submit"
          style={{
            padding: '10px 20px',
            borderRadius: '5px',
            backgroundColor: '#007BFF',
            color: 'white',
            border: 'none',
            cursor: 'pointer',
            fontSize: '16px',
          }}
        >
          Search
        </button>
      </form>

      {error && <p style={{ color: 'red' }}>{error}</p>}

      <Card sx={{ width: 765, backgroundColor: 'white', marginBottom: '20px', paddingBottom: '20px', borderRadius: '20px' }}>
  <div className='bg-white'>
    <div className='bg-white'>
      <div style={{ 'display': 'flex', padding: '5px' }}>
        <div>
          <p style={{ marginTop: "1rem", marginLeft: '25px' }}>
            <span style={{ fontWeight: "600" }}> <PersonIcon style={{marginTop:'-3px'}}/>  Owner Info</span>{" "}
          </p>

          <div style={{ display: 'flex', marginLeft: '55px' }}>
          {resultData && (
        <div>
          <div>
            <strong style={{marginLeft:'4px'}}>Name:</strong> {resultData.person.name.firstName} {resultData.person.name.lastName}
          </div>
          <div>
            <strong style={{marginLeft:'4px'}}>Age:</strong> {resultData.person.age}
          </div>
          
         
        </div>
      )}
            </div>
          
        </div>
      </div>

      
    </div>
  </div>
</Card>
      <Card sx={{ width: 765, backgroundColor: 'white', marginBottom: '20px', paddingBottom: '20px', borderRadius: '20px' }}>
  <div className='bg-white'>
    <div className='bg-white'>
      <div style={{ 'display': 'flex', padding: '5px' }}>
        <div>
          <p style={{ marginTop: "1rem", marginLeft: '25px' }}>
            <span style={{ fontWeight: "600" }}><HouseIcon style={{marginTop:'-3'}}/>Addresses</span>{" "}
          </p>

          <div style={{ display: 'flex', marginLeft: '55px' }}>
          {resultData && (
        <div>
          
          
          <div>
           
            <ul>
              {resultData.person.addresses.map((address, index) => (
                <>
                <li key={index} style={{fontWeight:'bold'}}>
                  {address.street}, {address.city}, {address.state} {address.zip} 
                </li>
                <li key={index} style={{marginBottom:'10px'}}>
                  (First reported: {address.firstReportedDate}, Last reported: {address.lastReportedDate})
                </li>
                </>
              ))}
            </ul>
          </div>
          
        </div>
      )}
            </div>
          
        </div>
      </div>

      
    </div>
  </div>
</Card>
      <Card sx={{ width: 765, backgroundColor: 'white', marginBottom: '20px', paddingBottom: '20px', borderRadius: '20px' }}>
  <div className='bg-white'>
    <div className='bg-white'>
      <div style={{ 'display': 'flex', padding: '5px' }}>
        <div>
          <p style={{ marginTop: "1rem", marginLeft: '25px' }}>
            <span style={{ fontWeight: "600" }}><EmailIcon style={{marginTop:'-3'}}/>Emails</span>{" "}
          </p>

          <div style={{ display: 'flex', marginLeft: '55px' }}>
          {resultData && (
        <div>
        <ul>
          {resultData.person.emails.map((email, index) => (
            <li key={index}>
              {email.email} (Validated: {email.isValidated ? 'Yes' : 'No'}, Business: {email.isBusiness ? 'Yes' : 'No'})
            </li>
          ))}
        </ul>
      </div>
      )}
            </div>
          
        </div>
      </div>

      
    </div>
  </div>
</Card>
      <Card sx={{ width: 765, backgroundColor: 'white', marginBottom: '20px', paddingBottom: '20px', borderRadius: '20px' }}>
  <div className='bg-white'>
    <div className='bg-white'>
      <div style={{ 'display': 'flex', padding: '5px' }}>
        <div>
          <p style={{ marginTop: "1rem", marginLeft: '25px' }}>
            <span style={{ fontWeight: "600" }}><PhoneAndroidIcon style={{marginTop:'-3px'}}/>Phone Numbers</span>{" "}
          </p>

          <div style={{ display: 'flex', marginLeft: '55px' }}>
          {resultData && (
        <div>
          
          <div>
            <ul>
              {resultData.person.phones.map((phone, index) => (
                <>
                <li key={index}>
                  <b>{phone.number}</b> 
                </li>
                <li key={index} style={{marginBottom:'10px'}}>
                  ({phone.type}, Connected: {phone.isConnected ? 'Yes' : 'No'}) (First reported: {phone.firstReportedDate}, Last reported: {phone.lastReportedDate})
                </li>
                </>
              ))}
            </ul>
          </div>
          
        </div>
      )}
            </div>
          
        </div>
      </div>

      
    </div>
  </div>
</Card>
      
    </div>
        </main>
         
          
        </>
     
    </div>
    </div>
  );


};

export default SkipTrace;


const styles = {
  container: {
    margin: '20px auto',
    maxWidth: '600px',
    fontFamily: 'Arial, sans-serif',
  },
  list: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
    width:'100%',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  listItem: {
    padding: '12px 16px',
    cursor: 'pointer',
    borderBottom: '1px solid #ddd',
    backgroundColor: '#fff',
    width:'100%',
    transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
  },
  listItemHover: {
    backgroundColor: '#f7f7f7',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
  centerScreen: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    minHeight: '100vh'
  },
  container1: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#fff',
    alignItems: 'center',
    height: '100%',
    marginTop:'0px'
  },
  profile: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#000222',
    padding: '10px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  profileAvatar: {
    width: '52px',
    height: '52px',
    borderRadius: '50%',
    marginRight: '21px',
  },
  profileName: {
    fontSize: '17px',
    fontWeight: 'bold',
    color: 'white',
    margin: 0,
  },
  profileHandle: {
    fontSize: '11px',
    color: 'white',
    margin: 0,
  },
  
};